import PropTypes from 'prop-types'
import React from 'react'

import { Wrapper, Container, Title, Description, Image } from './styles'
import image from './assets/image.png'

const BResultsRecommendations = ({ className }) => {
  const title = 'Your <span>personal</span> recommendations'
  const description = '<p>Based on the test results you will receive diet and lifestyle recommendations tailored for your gut microbiome\'s needs. The Top-10 foods weekly list is designed to nourish your bacteria, help them thrive, and boost your overall well-being.</p><p>Our questionnaire will help the AI collect more data about your lifestyle and food habits to make the test results more personalized.</p>'

  return (
    <Wrapper className={className}>
      <Container>
        <Title
          weight={'medium'}
          size={['50/60', '25/30', '25/30']}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        <Description
          size={['22/30', '16/20', '16/20']}
          dangerouslySetInnerHTML={{ __html: description }}
        />

        <Image src={image} alt='image' />
      </Container>
    </Wrapper>
  )
}

BResultsRecommendations.propTypes = {
  data: PropTypes.object.isRequired,
  className: PropTypes.string.isRequired,
  pathCdn: PropTypes.string.isRequired,
}

export default BResultsRecommendations
